export default __webpack_public_path__ + "static/media/pyramidSelected.22da29c2.png";